import {
	colorPalette,
	fontSize,
	fontWeight,
	mainLinks,
	supporter,
	fontFamily,
} from '../../config';
import {
	participateLogoImg,
	recogLogoImg,
	infoLogoImg,
	recordLogoImg,
	notifyLogoImg,
	support1,
	support2,
	cbsImg,
	gyeongSangImg,
	jinjuImg,
	courseImg,
} from '../../config/images';

const dateTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl5,
			tablet: '30px',
			mobile: '24px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
	unit: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '20px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		opacity: 0.64,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
	value: {
		fontSize: {
			desktop: fontSize.xl7,
			tablet: '44px',
			mobile: '38px',
		},
		color: colorPalette.white,
		fontWeight: fontWeight.bold,
		shadow: `0 0 10px rgba(0, 0, 0, 0.7);`,
	},
};

export const firstProps = {
	title: {
		type: 'h2',
		children: `제1회 구례지리산봄길마라톤대회`,
		fontSize: {
			desktop: fontSize.xl6,
			tablet: '45px',
			mobile: '24px',
		},
		fontFamily: 'Gmarket',
		color: colorPalette.primary,
		fontWeight: fontWeight.medium,
		// shadow: `0 0 10px rgba(0, 0, 0, 0.5);`,
	},
	content: {
		type: 'p',
		children: `2026년 5월 2일(토) 08:30  \n구례군 공설운동장`,
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '16px',
		},
		color: colorPalette.primary,
		fontWeight: fontWeight.semiBold,
		// shadow: `0 0 10px rgba(0, 0, 0, 0.6);`,
	},
	button: {
		text: {
			children: '신청하기',
			fontSize: {
				desktop: '18px',
				tablet: '22px',
				mobile: '16px',
			},
			lineHeight: 2.4,
			color: colorPalette.white,
			fontWeight: fontWeight.medium,
		},
		onClick: () =>
			(window.location.href = `${window.location.origin}/participation/person`),
		isRounded: true,
		// border: `2px solid ${colorPalette.white}`,
		// bgColor: 'transparent',
		bgColor: colorPalette.primary,
	},
	date: {
		title: {...dateTextProps.title, children: '행사 시작까지'},
		day: {...dateTextProps.unit, children: 'DAY'},
		dayValue: {...dateTextProps.value, children: '14'},
		hour: {...dateTextProps.unit, children: 'HOUR'},
		hourValue: {...dateTextProps.value, children: '8'},
		minute: {...dateTextProps.unit, children: 'MINUTES'},
		minuteValue: {...dateTextProps.value, children: '25'},
		second: {...dateTextProps.unit, children: 'SECONDS'},
		secondValue: {...dateTextProps.value, children: '32'},
	},
};

const secondTextProps = {
	title: {
		fontSize: {
			desktop: '26px',
			tablet: '26px',
			mobile: '26px',
		},
		color: colorPalette.primary,
		fontWeight: fontWeight.medium,
		fontFamily: 'Gmarket',
	},
	content: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		color: colorPalette.noneBorder,
		fontWeight: fontWeight.base,
		fontFamily: 'Gmarket',
	},
	support: {
		fontSize: {
			desktop: fontSize.xl2,
			tablet: '22px',
			mobile: '15px',
		},
		color: colorPalette.base,
		fontWeight: fontWeight.semiBold,
	},
};

export const secondProps = {
	info: {
		title: {
			...secondTextProps.title,
			children: '마라톤 알아보기',
		},
		content: {
			...secondTextProps.content,
			children: `마라톤에 도움이 되는 바로가기\n정보를 안내합니다.`,
		},
		links: mainLinks,
	},
	supports: supporter,
};

export const thirdTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '26px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: '16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.white,
	},
	item: {
		title: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '18px',
			},
			color: colorPalette.realBlack,
			fontWeight: fontWeight.bold,
			lineHeight: '30px',
		},
		content: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.realBlack,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
		smalContent: {
			fontSize: {
				desktop: fontSize.base,
				tablet: '16px',
				mobile: '16px',
			},
			color: colorPalette.primary,
			fontWeight: fontWeight.medium,
		},
		accentContent: {
			fontSize: {
				desktop: '20px',
				tablet: '20px',
				mobile: '16px',
			},
			color: colorPalette.primary,
			fontWeight: fontWeight.normal,
			lineHeight: '30px',
		},
	},
};

export const thirdProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.white,
		height: '3px',
		text: {...thirdTextProps.title, children: '대회요강', type: 'p'},
		description: {
			...thirdTextProps.description,
			children: '반드시 참가 유의사항을 읽고 신청해 주세요.',
		},
	},
	first: [
		{
			title: {...thirdTextProps.item.title, children: '대회명'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `제1회 구례지리산봄길마라톤대회`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '대회일시'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `2026년 5월 2일 (토)`,
				},
				{
					...thirdTextProps.item.content,
					children: `08:30 하프코스 출발\n08:40 10km코스 출발\n08:50 5km코스 출발\n`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '집결시간'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `오전 8시`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '장소'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `구례군 공설운동장`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가구분'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `하프코스/10km코스/5km코스`,
				},
				{
					...thirdTextProps.item.content,
					children: `3가지 코스 중 선택 가능`,
				},
			],
		},
	],
	second: [
		{
			title: {...thirdTextProps.item.title, children: '참가자격'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `나이제한 없으며, 신체 건강한 남 / 녀`,
				},
				{
					...thirdTextProps.item.smalContent,
					children: `대한육상경기연맹 등록선수 및 선수등록 말소 후\n2년 경과되지 않은 자는 시상에서 제외됩니다.`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수기간'},
			contents: [
				{
					...thirdTextProps.item.title,
					children: `선착순 마감(4월 17일 최종마감)`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '접수방법'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `인터넷으로만 접수`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '모집인원'},
			contents: [
				{
					...thirdTextProps.item.accentContent,
					children: `하프코스 1,000명 \n10km 1,500명 \n5km 1,500명`,
				},
			],
		},
		{
			title: {...thirdTextProps.item.title, children: '참가비'},
			contents: [
				{
					...thirdTextProps.item.content,
					children: `하프코스 - 35,000원\n10km코스 - 35,000원\n5km코스 - 20,000원`,
				},
				{
					...thirdTextProps.item.smalContent,
					children: `\n광주은행 (주)오마이뉴스광주전라본부 1107-021-927109`,
				},
			],
		},
	],
};

const fourthTextProps = {
	title: {
		fontSize: {
			desktop: fontSize.xl3,
			tablet: '36px',
			mobile: '24px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.black,
		fontFamily: 'Gmarket',
	},
	description: {
		fontSize: {
			desktop: '16px',
			tablet: '16px',
			mobile: ' 16px',
		},
		fontWeight: fontWeight.medium,
		color: colorPalette.engTitle,
	},
};

export const fourthProps = {
	title: {
		textAlign: 'left',
		bgColor: colorPalette.primary,
		height: '5px',
		text: {...fourthTextProps.title, children: '대회코스', type: 'p'},
		description: {
			...fourthTextProps.description,
			children: '대회 구간을 참고하시고 신청 바랍니다',
		},
	},
	course: {
		src: courseImg,
		alt: '코스',
		borderRadius: '1.375rem',
	},
};

export const modalProps = {
	isClose: true,
	imgs: [{src: courseImg}, {src: ''}],
};
